import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex items-center justify-center min-h-full p-4 text-center sm:p-0" }
const _hoisted_3 = { class: "absolute top-0 right-0 block pt-4 pr-4" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5 sm:p-6" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "text-lg font-medium text-clay-800" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "gap-3 px-4 py-4 space-y-3 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 bg-clay-50 sm:px-6 sm:space-y-0" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]


import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {store} from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'SaLoginDialog',
  setup(__props) {

// @ts-ignore
const redirectUrl = () => {
    return window.location.href.substring(window.location.origin.length);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: _unref(store).showLoginDialog,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-40",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).showLoginDialog = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative w-full max-w-lg overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          class: "text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden",
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).showLoginDialog = false))
                        }, _cache[3] || (_cache[3] = [
                          _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                          _createElementVNode("svg", {
                            class: "w-6 h-6",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            viewBox: "0 0 24 24",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M6 18L18 6M6 6l12 12",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1)
                        ]))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(DialogTitle), {
                            as: "h3",
                            class: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Hello Stranger! ")
                            ])),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("p", _hoisted_6, [
                              _cache[5] || (_cache[5] = _createTextVNode(" Please ")),
                              _createElementVNode("a", {
                                class: "text-gray-700 underline hover:text-gray-900",
                                href: `/login?redirect=${redirectUrl()}`
                              }, "log in", 8, _hoisted_7),
                              _cache[6] || (_cache[6] = _createTextVNode(" or ")),
                              _createElementVNode("a", {
                                class: "text-gray-700 underline hover:text-gray-900",
                                href: `/signup?redirect=${redirectUrl()}`
                              }, "sign up", 8, _hoisted_8),
                              _cache[7] || (_cache[7] = _createTextVNode(" to continue. "))
                            ])
                          ])
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("img", {
                          class: "mx-auto max-h-48",
                          src: "https://stagea.blob.core.windows.net/assets/home/images/SongsLandingImgOpera.png"
                        }, null, -1))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("a", {
                          class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-electric-500 focus:ring-offset-2 sm:col-start-1 sm:text-sm",
                          href: `/login?redirect=${redirectUrl()}`
                        }, "Login", 8, _hoisted_10),
                        _createElementVNode("a", {
                          class: "inline-flex justify-center w-full px-4 py-2 text-base font-semibold border border-transparent rounded-md shadow-sm bg-electric-600 text-white hover:bg-electric-700 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-electric-700 sm:col-start-2 sm:mt-0 sm:text-sm",
                          href: `/signup?redirect=${redirectUrl()}`
                        }, "Sign up", 8, _hoisted_11)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})